import { render, staticRenderFns } from "./BoAnakPerusahaan.vue?vue&type=template&id=27b70a18"
import script from "./BoAnakPerusahaan.vue?vue&type=script&lang=js"
export * from "./BoAnakPerusahaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports